import i18n from '@/i18n';

import type { OpsPublishOption } from '.';

/** 根据当前语言返回 Skill 广场分类名称，中文取 ChineseName，其他语言取 Name。 */
function getLocalizedSkillTypeName(name: string, chineseName: string): string {
  const language = i18n.resolvedLanguage || i18n.language;
  return language?.toLowerCase().startsWith('zh') ? chineseName : name;
}

/** Skill 广场分类；value 为固定英文 key，label 随语言切换。 */
export const SKILL_TYPE_OPTIONS: OpsPublishOption[] = [
  ['Skills', 'Skills管理'],
  ['DevTools', '开发工具'],
  ['Marketing', '市场推广'],
  ['Frontend', '前端开发'],
  ['MediaAI', '媒体处理'],
  ['Quality', '代码质检'],
  ['Mobile', '移动开发'],
  ['CloudOps', '云效工具'],
  ['Other', '其他'],
].map(([name, chineseName]) => ({
  get label() {
    return getLocalizedSkillTypeName(name, chineseName);
  },
  value: name,
}));
